var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-shell"},[_c('base-header'),_c('div',{staticClass:"container pt-4"},[_c('router-view'),_c('base-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }